export default __webpack_public_path__ + "static/media/EmailInitial.6e44a7f4.svg";